/** Genera suma simple con 3 opciones (1 correcta, 2 incorrectas). */
export function createSumCaptcha() {
  const a = Math.floor(Math.random() * 9) + 1;
  const b = Math.floor(Math.random() * 9) + 1;
  const correct = a + b;

  const wrong = new Set();
  while (wrong.size < 2) {
    const delta = Math.floor(Math.random() * 5) + 1;
    const candidate = correct + (Math.random() > 0.5 ? delta : -delta);
    if (candidate > 0 && candidate !== correct) wrong.add(candidate);
  }

  const options = [correct, ...wrong];
  for (let i = options.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [options[i], options[j]] = [options[j], options[i]];
  }

  return { a, b, correct, options };
}
